import {
  LeftCarouselGradient,
  RightCarouselGradient,
  ScrollSnapCarousel,
} from 'src/pages/components/ScrollSnapCarousel';
import { ifNotProp } from 'src/shared/styled-utils/ifNotProp';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { Border, Colors, Font, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

const DATES_LEFT_SPACING = '14px';

export const Dates = styled(ScrollSnapCarousel)`
  margin-top: ${Spacing.SINGLE};
  justify-content: flex-start;
  width: calc(100% + 28px);
  left: -${DATES_LEFT_SPACING};

  @media (min-width: ${ScreenWidth.SMALL}) {
    width: 100%;
    left: 0;
  }

  ${LeftCarouselGradient} {
    background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, ${Colors.WHITE} 100%);
    z-index: auto;
  }

  ${RightCarouselGradient} {
    background: linear-gradient(270deg, ${Colors.WHITE} 0%, rgba(255, 255, 255, 0) 100%);
    z-index: auto;
  }
`;

export const DayOfWeek = styled.span`
  font-size: ${Font.Size.XXXS};
  line-height: ${Font.Size.XXXS};

  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 1.5px;
  text-transform: uppercase;

  color: ${Colors.GRAY_DARK_10};

  flex: none;
  order: 0;
  flex-grow: 0;
  margin-bottom: ${Spacing.EIGHTH};
`;

export const MonthDay = styled.span`
  font-size: ${Font.Size.XS};
  line-height: ${Font.Size.XS};

  display: flex;
  align-items: center;
  text-align: center;

  color: ${Colors.GRAY_DARK_30};

  flex: none;
  order: 1;
  flex-grow: 0;
`;

export const NumShefs = styled.span`
  font-size: ${Font.Size.XXS};
  line-height: ${Font.Size.XXS};

  display: flex;
  align-items: center;
  text-align: center;

  color: ${Colors.GRAY_DARK_10};

  margin-top: auto;

  flex: none;
  order: 1;
  flex-grow: 0;
`;

export const DeliveryDayButton = styled.button.attrs(({ isSelected }: { isSelected?: boolean }) => ({
  'data-selected': isSelected,
}))<{ first?: boolean; isSelected?: boolean; isSoldOut?: boolean }>`
  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: ${Font.Weight.SEMI_BOLD};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${Spacing.SINGLE} ${Spacing.HALF} ${Spacing.HALF};
  border-radius: ${Border.Radius.S};

  width: 84px;
  height: 72px;
  margin: ${Spacing.NONE} ${Spacing.QUARTER};

  ${ifProp(
    'isSoldOut',
    css`
      ${DayOfWeek}, ${MonthDay} {
        color: ${Colors.GRAY};
      }
    `
  )}

  ${ifProp(
    'isSelected',
    css`
      background: ${Colors.GRAY_DARK_30};
      border: none;

      ${DayOfWeek} {
        color: ${Colors.JACKFRUIT};
      }

      ${MonthDay} {
        color: ${Colors.WHITE};
      }

      ${NumShefs} {
        color: ${Colors.WHITE};
        opacity: 0.7;
      }
    `
  )}

  ${ifProp(
    'first',
    css`
      margin-left: ${DATES_LEFT_SPACING};
      @media (min-width: ${ScreenWidth.SMALL}) {
        margin-left: ${Spacing.QUARTER};
      }
    `
  )}

  ${ifNotProp(
    'isSelected',
    css`
      background: ${Colors.WHITE};
      border: ${Border.Base} ${Colors.GRAY_LITE_10};
      box-sizing: border-box;
    `
  )}

  flex: none;
  flex-grow: 0;
`;

export const Date = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${Spacing.NONE};

  flex: none;
  order: 0;
  flex-grow: 0;
`;
